<template>
	<b-badge :pill="pill" :variant="variant" :style="{ backgroundColor: bgColor }" v-bind="$attrs" :class="icon ? 'text-center' : ''">
	  <span v-if="!icon" v-text="label" />
	  <font-awesome-icon v-else :icon="statusIcon" class="mx-0 px-0" />
	</b-badge>
  </template>
  
  <script>
  import { mapGetters } from "vuex";
  
  export default {
	name: "CaseRequestStatusLabel",
	props: {
	  value: {
		type: Object,
		required: true,
		default: () => {
		  return {
			request_status: null,
			status_label: null,
			unable_to_complete: false, // ensure this field is included
		  };
		},
	  },
	  icon: {
		type: Boolean,
		default: false,
	  },
	  noColor: {
		type: Boolean,
		default: false,
	  },
	  pill: {
		type: Boolean,
		default: true,
	  },
	},
	computed: {
		label() {
    
    
    // Check if the unable_to_complete field is true
    if (this.value.unable_to_complete) {
      return 'Unable to Complete'; // Custom label for unable_to_complete
    }
    
    // Check the value of request_status or status_label
    const value = this.value || this.value.request_status;
    
    
		// Handle status-specific labels
		if (value === 'InProcess') {
		  return 'In Process';
		}
		return value || "Unknown";
	  },
	  variant() {
		if (this.noColor) {
		  return "light";
		}
		
		// Handle color based on status and "unable_to_complete"
		if (this.value.unable_to_complete) {
		  return "warning"; // Color for "Unable To Complete"
		}
		if (this.value.status && this.value.request_status==='Returned') {
		  return "updated"; // Color for "Unable To Complete"
		}
		if (this.value.request_status=='Uploaded') {
		  return "updated"; // Color for "Unable To Complete"
		}
  
		switch (this.value.request_status || this.value) {
		  case "Open":
			return "primary";
		  case "Active":
			return "#008FFF";
		  case "Submitted":
			return "info";
		  case "Returned":
			return "updated";
			case "Re-work":
			return "info";
		  case "In Progress":
			return "#8EA7DE";
		  case "Closed":
			return "success";
		  case "Completed":
			return "success";
		  default:
			return "primary";
		}
	  },
	  statusIcon() {
		// Handle icon based on status and "unable_to_complete"
		if (this.value.unable_to_complete) {
		  return "exclamation-triangle"; // Icon for "Unable To Complete"
		}
  
		switch (this.value.request_status) {
		  case "Open":
			return "envelope-open";
		  case "InProcess":
			return "check-circle";
			case "Submitted":
			return "users";
			case "Re-work":
			return "users";
			case "Returned":
			return "users";
		  case "Completed":
			return "check-circle";
		  case "Closed":
			return "check-circle";
		  default:
			return "info-circle";
		}
	  },
	  ...mapGetters({
		statuses: "caseRequests/statuses",
	  }),
	},
  };
  </script>
  